// legacy ajax method for backward-compatibility with jQuery
export default function ajax(url, data, options = {}) {
    const requestOptions = {
        method: options?.method ?? 'POST',
        credentials: 'same-origin',
    };
    if (options?.dataType === 'json') {
        requestOptions.body = JSON.stringify(data);
        requestOptions.headers = {
            'Content-Type': 'application/json',
        };
    }
    else {
        requestOptions.body = makeFormData(data, options.submitter);
    }
    return fetch(url, requestOptions);
}
export function makeFormData(data, submitter) {
    if (data instanceof FormData) {
        return data;
    }
    if (data instanceof HTMLFormElement) {
        return new FormData(data, submitter);
    }
    const formData = new FormData();
    for (const name in data) {
        if (data.hasOwnProperty(name) && data[name] !== undefined) {
            formData.append(name, data[name]);
        }
    }
    return formData;
}
